var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCheckGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/navigation/ic-check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.795,15.875 L5.32961259,12.4096126 C4.9400637,12.0200637 4.30882497,12.0189484 3.91790203,12.4071184 L3.915,12.41 C3.52426097,12.7979873 3.52203029,13.4292698 3.91001764,13.8200088 C3.91084509,13.8208422 3.91167402,13.821674 3.91250442,13.8225044 L8.08789322,17.9978932 C8.47841751,18.3884175 9.11158249,18.3884175 9.50210678,17.9978932 L20.09,7.41 C20.4793607,7.02063925 20.4793607,6.38936075 20.09,6 L20.09,6 C19.7005854,5.61058539 19.0692656,5.61043629 18.6796671,5.9996669 L8.795,15.875 Z",
    id: "path-8574169"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/navigation/ic-check",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-8574169"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon/navigation/check_24px",
    fill: "#02bd70",
    xlinkHref: "#path-8574169"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckGreen);
export default __webpack_public_path__ + "static/media/ic-check-green.7db52cf0e02cc2592ba632dd3dc65464.svg";
export { ForwardRef as ReactComponent };